import request from "@/axios/http";

// 通知公告
export function notice(prams) {
  return request({
    url: "/stage-api/system/notice/list",
    method: "get",
    prams,
  });
}
// 网站帮助
export function help(prams) {
  return request({
    url: "/stage-api/pre/center/list",
    method: "get",
    prams,
  });
}

// 十大缩水学霸-人气列表
export function queryPopularityList(data) {
  return request({
    url: "/stage-api/pre/record/queryPopularityList",
    method: "post",
    timeout: 0,
    data,
  });
}
// 十大缩水学霸-指标列表
export function queryPreRankingList(data) {
  return request({
    url: "/stage-api/pre/record/queryPreRankingList",
    method: "post",
    data,
  });
}
// 十大缩水学霸-弹窗列表分页
export function queryPreRankingPageList(data, params = {}) {
  return request({
    url: "/stage-api/pre/record/queryPreRankingPageList",
    method: "post",
    data,
    params,
  });
}

// 人气分页
export function queryPopularityPageList(data) {
  return request({
    url: "/stage-api/pre/record/queryPopularityPageList",
    method: "post",
    data,
  });
}

// 根据期数获取彩种信息
export function queryColorfulSeedByType(type) {
  return request({
    url: "/stage-api/lottery/consult/queryColorfulSeedByType/" + type,
    method: "get",
  });
}

export function getInfo(data) {
  return request({
    url: "/stage-api/getUserInfo",
    method: "get",
    data,
  });
}
// 站内信
export function notice_list(data) {
  return request({
    url: "/stage-api/cms/pre_notice/notice_list",
    method: "get",
    data,
  });
}

// 查询指定期数对应预测信息
export function queryPreRecorDetailList(params, data) {
  return request({
    url: "/stage-api/pre/record/queryPreRecorDetailList" + params,
    method: "post",
    data,
  });
}

// 查询指标信息
export function queryProindexInfo(params) {
  return request({
    url: "/stage-api/pre/detail/additional/indicators",
    method: "get",
    params,
  });
}

// 查询下载预测文件所需价格
export function queryDownloadFilePriceByRecordId(data) {
  return request({
    url: "/stage-api/pre/record/queryDownloadFilePriceByRecordId",
    method: "post",
    data,
  });
}

// 下载文件
export function detail_download(params) {
  return request({
    url: "/stage-api/pre/detail/download",
    method: "get",
    params,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    responseType: "blob",
    timeout: 0, //0s
    onDownloadProgress: (progressEvent) => {
      // console.log('progressEvent',progressEvent);
      // 计算下载百分比
      let percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      );
      console.log(percentCompleted + "% 已下载");

      let element = document.getElementById("downloadFile");
      if (!element) {
        element = document.createElement("div");
        element.id = "downloadFile";
        let body = document.querySelector("body");
        body.appendChild(element);
      }

      element.style.cssText = `
				position: fixed;
				left: 0;
				bottom: 0;
				z-index: 20;
				background-color: red;
				color: #fff;
				padding: 20px;
				font-weight: bold;
			`;

      let loadedSize = formatBytes(progressEvent.loaded);
      element.textContent = " 已下载" + percentCompleted + "%----" + loadedSize;

      function formatBytes(bytes) {
        if (bytes < 1024) {
          return bytes + " B";
        } else if (bytes < 1048576) {
          return (bytes / 1024).toFixed(2) + " KB";
        } else if (bytes < 1073741824) {
          return (bytes / 1048576).toFixed(2) + " MB";
        } else {
          return (bytes / 1073741824).toFixed(2) + " GB";
        }
      }
    },
  });
}

// 帮扶超市
export function schemelist(params) {
  return request({
    url: "/stage-api/assist/market/scheme/list",
    method: "get",
    params,
  });
}

// 查询开奖信息
export function queryOpennumberInfo(params) {
  return request({
    url: "/stage-api/pre/detail/open/number",
    method: "get",
    params,
  });
}

// 缩水软件特区列表 - 首页
export function softwareList(data) {
  return request({
    url: "/stage-api/software/software/list",
    method: "post",
    data,
  });
}
